import {
  Component,
  Input,
  OnInit,
  TemplateRef,
  ViewChild,
} from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { VendorOrder } from '@models/vendor-order';
import { FormatData } from '@classes/format-data';
import { sortLogsByDateDesc } from '@v2/shared/utils';

@Component({
  selector: 'app-invoice-log',
  templateUrl: './invoice-log.component.html',
  styleUrls: ['./invoice-log.component.scss'],
})
export class InvoiceLogComponent {
  @Input() order: VendorOrder;
  @ViewChild('logDetail') logModal: TemplateRef<any>;

  constructor(private dialog: MatDialog) {}

  get sortedLogs() {
    return sortLogsByDateDesc(this.order?.log);
  }

  vieOrderLog() {
    this.dialog.open(this.logModal, {
      panelClass: 'order-log-dialog-panel',
    });
  }

  logChangeArrow = FormatData.LOG_CHANGE_ARROW;

  logItemParts(item?: string) {
    return FormatData.parseLogItem(item);
  }

  hasLogTime(date?: string): boolean {
    if (!date) {
      return false;
    }
    const raw = String(date).trim();
    if (/^\d+$/.test(raw)) {
      return true;
    }
    const parsed = new Date(raw);
    if (isNaN(parsed.getTime())) {
      return false;
    }
    return (
      parsed.getHours() !== 0 ||
      parsed.getMinutes() !== 0 ||
      parsed.getSeconds() !== 0
    );
  }
}
